/**
 *  __  __
 * |  \/  |
 * | \  / | _____   ____ ___  __
 * | |\/| |/ _ \ \ / / _` \ \/ /
 * | |  | | (_) \ V / (_| |>  <
 * |_|  |_|\___/ \_/ \__,_/_/\_\
 */

// import branchBar from './modules/branch-bar';
import '@crasman/branch-bar/styles.css';
import { branchBar } from '@crasman/branch-bar';
import isotopeGrid from './components/isotope-grid';
import floatingLabel from './components/floating-label';
import tooltip from './components/tooltip';
import machineSearch from './components/machine-search'
import customerMachineSearch from './components/customer-machine-search';
import mobileNav from './components/mobile-nav';
import emails from './components/emails';
// import dataTables from './components/datatable-sorting';
import './modules/register-service-worker';

//Initialize everything on document ready
export default function master () {
  branchBar.init();
  isotopeGrid.init();
  floatingLabel.init();
  tooltip();
  machineSearch();
  customerMachineSearch();
  mobileNav.init();
  emails.init();
  // dataTables();
}
